import { render, staticRenderFns } from "./AddVatRate.vue?vue&type=template&id=453a67da"
import script from "./AddVatRate.vue?vue&type=script&lang=ts"
export * from "./AddVatRate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports